import { Component, OnInit } from '@angular/core';

import { CookieService } from '../../../../../providers/cookie.service';
import { ClientService } from '../../../services/client/client.service';
import { ExportService } from '../../../services/export/client/export.service';


export class CandidateProfileComponent implements OnInit {

	public guestEmail: string = '';
	public isTrusted: boolean = false;
	public showAuthArea: boolean = false;
	public dataLoaded: boolean = false;
	public exportProfileInProgress: boolean = false;
	public validatingGuestEmail: boolean = false;

	private client: any;

	constructor(
		private cookieService: CookieService,
		private clientService: ClientService,
		private exportService: ExportService) { }

	/* Lifecycle events */
	public ngOnInit(): void {
		let cookie = this.cookieService.get();

		// check cookie
		if (!cookie) {
			this.dataLoaded = true;
			this.showAuthArea = true;
			return;
		}

		// check cookie type and id
		if (!cookie.hasOwnProperty('user_type') || cookie.user_type !== 'client' || !cookie.client || !cookie.client.id) {
			this.dataLoaded = true;
			this.showAuthArea = true;
			return;
		}

		// check if is the same client
		this.getClient(cookie.client.id);
	}

	/* Events */
	public onInviteTestFormSubmit(): void {
		if (!this.guestEmail) {
			return;
		}

		this.validatingGuestEmail = true;
		this.clientService.validateEmail({email: this.guestEmail}).subscribe(
			(resp) => {
				this.validatingGuestEmail = false;
				this.showAuthArea = false;

				// all good, show export profile flow
				this.isTrusted = true;
			},
			(err) => {
				this.validatingGuestEmail = false;
			}
		);

	}

	public onExportProfileClick(): void {
		this.exportProfileInProgress = true;
		this.exportService.exportProfile().subscribe(
			(pdfUrl) => {
				if (pdfUrl) {
					window.location.assign(pdfUrl);
					this.exportProfileInProgress = false;

					return;
				}
				this.exportProfileInProgress = false;
			}
		);
	}

	/* Services calls */
	private getClient(loggedClientId: string): void {
		this.clientService.get().subscribe(
			(client) => {
				this.dataLoaded = true;
				if (client.id === loggedClientId) {
					this.isTrusted = true;

					return;
				}

				this.showAuthArea = true;
			}
		);
	}

	/* Helpers */
static ctorParameters() { return [ { type: CookieService }, { type: ClientService }, { type: ExportService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/guest/components/client/candidate-profile/candidate-profile.component.ts